module.exports = __webpack_public_path__ + "static/img/social video-微电影&剧情故事.66add4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/social video-微电影&剧情故事.png
// module id = QL+Q
// module chunks = 1